import { render } from "./RelatorioEstacao.vue?vue&type=template&id=18a64912&scoped=true"
import script from "./RelatorioEstacao.vue?vue&type=script&lang=js"
export * from "./RelatorioEstacao.vue?vue&type=script&lang=js"

import "./RelatorioEstacao.vue?vue&type=style&index=0&id=18a64912&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a64912"]])

export default __exports__